import { render } from "./SortingBar.vue?vue&type=template&id=6986e0f3"
import script from "./SortingBar.vue?vue&type=script&lang=js"
export * from "./SortingBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__